import i18n from 'i18n-js';
import { ViewStyle } from 'react-native';

import { WithColor } from '@styles/colors';
import { FontStyles } from '@styles/fonts';
import { ClampingTool } from '@interfaces/search';
import { convertTimeLetter, formatTimeEvent } from '@helpers';

export interface ToolsTableColumn {
  key: keyof ClampingTool;
  title: string;
  width: ViewStyle['width'];
  color: string;
  titleColor: string;
  sort?: boolean;
  orderBy?: string;
  valueFont?: keyof FontStyles;
  // Optional formatter for the cell value; falls back to the raw field when absent
  formatValue?: (item: ClampingTool) => string;
}

// machiningDuration is stored in seconds; render it as "6m 6s" (empty when 0/null)
const formatToolTime = (item: ClampingTool) => formatTimeEvent(convertTimeLetter(item.machiningDuration ?? 0));

// toolStickoutMM is a number in millimetres; append the unit (empty when null)
const formatToolStickout = (item: ClampingTool) => (item.toolStickoutMM != null ? `${item.toolStickoutMM} ${i18n.t('mm')}` : '');

// Column descriptors for the tools table; depends on C for colors
export const buildToolsTableConfig = ({ C }: WithColor): ToolsTableColumn[] => [
  {
    key: 'toolName',
    title: 'Tool',
    width: '25%',
    color: C('Label/Light/Primary'),
    titleColor: C('Label/Light/Secondary'),
    sort: true,
    orderBy: 'toolName',
    valueFont: 'Headline',
  },
  {
    key: 'toolDescription',
    title: 'Description',
    width: '25%',
    color: C('Label/Light/Tertiary'),
    titleColor: C('Label/Light/Secondary'),
    sort: true,
    orderBy: 'toolDescription',
  },
  {
    key: 'toolMemo',
    title: 'Memo',
    width: '20%',
    color: C('Label/Light/Tertiary'),
    titleColor: C('Label/Light/Secondary'),
    sort: true,
    orderBy: 'toolMemo',
  },
  {
    key: 'toolStickoutMM',
    title: 'Stickout',
    width: '15%',
    color: C('Label/Light/Tertiary'),
    titleColor: C('Label/Light/Secondary'),
    sort: true,
    orderBy: 'toolStickoutMM',
    formatValue: formatToolStickout,
  },
  {
    key: 'machiningDuration',
    title: 'Time',
    width: '15%',
    color: C('Label/Light/Tertiary'),
    titleColor: C('Label/Light/Secondary'),
    sort: true,
    orderBy: 'machiningDuration',
    formatValue: formatToolTime,
  },
];
